const loadFacebookSDK = async () => {
  var js,
      fjs = document.getElementsByTagName("script")[0];
    if (document.getElementById('facebook-jssdk')) {
      return;
    }
    js = document.createElement("script");
    js.id = 'facebook-jssdk';
    js.src = "https://connect.facebook.net/pt_BR/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}

const initFacebook = async () => {
  return new Promise((resolve) => {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
        cookie: true,
        version: "v13.0"
      });
      resolve()
    }
  })
}

const login = async () => {
  return new Promise((resolve) => {
    window.FB.login(function(response) {
      resolve(response)
    }, { scope: 'public_profile,email' })
  })
}

export default {
  loadFacebookSDK,
  initFacebook,
  login
}